import { useContext } from '@nuxtjs/composition-api';
import { UserItem } from '~/types/user-items';
import { getUniqueInventoryPath } from '~/utils/userItem';

export enum ERoute {
  FILM = 'film',
  PROJECT_COLLECTION = 'project-collection',
  COLLECTION = 'collection',
  COLLECTION_ITEM = 'collection-item',
  FILM_TOKEN = 'film-token',
  FILM_BOOST = 'film-boost',
  HOME = '',
}

export interface IPageRouteParams {
  route?: ERoute;
  projectSlug?: string;
  url?: string;
  hash?: string | 'watch' | 'store' | 'director-cuts-tab';
  item?: UserItem;
}

export const usePageRoute = () => {
  const { store } = useContext();

  const buildUrl = (params: IPageRouteParams) => {
    switch (params.route) {
      case ERoute.FILM:
        return `/films/${params.projectSlug}`;
      case ERoute.PROJECT_COLLECTION:
        return `/collection/${params.projectSlug}`;
      case ERoute.COLLECTION:
        return `/collection`;
      case ERoute.FILM_BOOST:
        return `/film-boost/${params.projectSlug}`;
      case ERoute.COLLECTION_ITEM:
        if (!params.item) {
          throw new Error('Item is required for route');
        }
        const uniqueInventoryPath = getUniqueInventoryPath(
          params.item as UserItem,
        );
        const queries = `?selector=${encodeURIComponent(uniqueInventoryPath)}`;
        return `/my-collection/nfts/item${queries}`;
      case ERoute.FILM_TOKEN:
        return `/film-token`;
      default:
        return '/';
    }
  };

  const addUrlHash = (url: string, params: IPageRouteParams) => {
    if (!params.hash) {
      return url;
    }
    return `${url}#${params.hash}`;
  };

  const goTo = (params: IPageRouteParams) => {
    try {
      let url: string = params.url || buildUrl(params);
      url = addUrlHash(url, params);
      store.$router.push(url);
    } catch (e) {
      console.error(e);
    }
  };

  const getUrl = (params: IPageRouteParams) => {
    try {
      let url: string = params.url || buildUrl(params);
      url = addUrlHash(url, params);
      return url;
    } catch (e) {
      console.error(e);
    }
  };

  return {
    goTo,
    getUrl,
  };
};
